import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { NavbarItemLink } from '../components/navbar/navbar-item/interface';
import UQNavbar from '../components/navbar';

import logo_dark from '../assets/images/logos/logo_dark_new.svg?url';
import logo_light from '../assets/images/logos/logo_light_new.svg?url';
import logo_light_small from '../assets/images/logos/logo_cube.svg?url';
import logo_dark_small from '../assets/images/logos/logo_cube.svg?url';

const links: NavbarItemLink[] = [
  {
    text: "Home",
    url: '/',
    icon: 'home-01',
  },
  {
    text: "Actions",
    url: '/actions',
    disabled: true,
    icon: 'loader-01',
    subLevel: [
      { text: "Button", url: '/components/button' },
      { text: "Dropdown", url: '/components/dropdown' },
      { text: "FileRead", url: '/components/file-read' },
      { text: "Modal", url: '/components/modal' },
      { text: "Checkbox", url: '/components/checkbox' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    text: "Data Display",
    url: '/datadisplay',
    icon: 'card-01',
    disabled: true,
    subLevel: [
      { text: "Accordion", url: '/components/accordion' },
      { text: "Breadcrumb", url: '/components/breadcrumb' },
      { text: "Card", url: '/components/card' },
      { text: "Card Big Text", url: '/components/card-big-text' },
      { text: "Charts", url: '/components/charts' },
      { text: "Data Grid", url: '/components/data-grid' },
      { text: "Progress Bar", url: '/components/progress-bar' },
      { text: "Statistic Card", url: '/components/statistic-card' },
      { text: "Table Sort Search", url: '/components/table-sort-search' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    text: "Navigation",
    url: '/navigation',
    disabled: true,
    icon: 'link',
    subLevel: [
      { text: "Menu", url: '/components/menu' },
      { text: "Navbar", url: '/components/navbar' },
      { text: "Toggle-Menu", url: '/components/togglemenu' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    text: "Feedback",
    url: '/feedback',
    disabled: true,
    icon: 'message-square-typing',
    subLevel: [
      { text: "Loader", url: '/components/loader' },
      { text: "Toast", url: '/components/toast' },
      { text: "Tooltip", url: '/components/tooltip' },
    ].sort((a, b) => a.text.localeCompare(b.text)),
  },
  {
    text: "Data Input",
    url: '/datainput',
    icon: 'edit-03',
    disabled: true,
    subLevel: [
      { text: "Input", url: '/components/input' },
      { text: "Label", url: '/components/label' },
    ],
  },
  {
    text: "Layout",
    url: '/layout',
    icon: 'code-03',
    disabled: true,
    subLevel: [
      { text: "Divider", url: '/components/divider' },
      { text: "Grid", url: '/components/grid' },
      { text: "Spacer", url: '/components/spacer' },
    ],
  },
  {
    text: "Mockup",
    url: '/mockup',
    icon: 'embed',
    subLevel: [
      { text: "Code", url: '/components/code' },
    ],
  },
  {
    text: "Icons",
    url: '/components/icons',
    icon: 'image-no-borders',
    subLevel: [
      { text: "Catalog", url: '/components/icons' },
    ],
  },
];

const footerLinks: NavbarItemLink[] = [
  {
    url: '/about',
    text: 'About',
    icon: 'help-circle-contained',
  },
];

const Pages = () => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = React.useState(window.innerWidth < 1024); // Auto-collapse on tablet and mobile

  React.useEffect(() => {
    const handleResize = () => {
      const shouldCollapse = window.innerWidth < 1024; // Collapse on tablet and mobile
      setIsCollapsed(shouldCollapse);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <UQNavbar
      location={location}
      links={links}
      logoLight={logo_light}
      logoDark={logo_dark}
      logoLightSmall={logo_light_small}
      logoDarkSmall={logo_dark_small}
      footerLinks={footerLinks}
      singleCollapse={true}
      content={<Outlet />}
      horizontalCollapsed={isCollapsed}
      renderLink={(link, children) => (
        <Link to={link.url} className="navbar-item-base">
          {children}
        </Link>
      )}
    />
  );
};

export default Pages;

export { default as Home } from './home';
export { default as ButtonPage } from './button';
export { default as DropdownPage } from './dropdown';
export { default as ModalPage } from './modal';
export { default as IconsPage } from './icons';
export { default as AccordionPage } from './accordion';
export { default as ToastPage } from './toast';
export { default as AboutPage } from './about';
export { default as NotFoundPage } from './not-found';
export { default as GridPage } from './grid';
export { default as CardBigTextPage } from './card-big-text';
export { default as LoaderPage } from './loader';
export { default as ComponentsPage } from './components';
export { default as CodePage } from './code';
export { default as InputPage } from './input';
export { default as NavbarPage } from './navbar';
export { default as MenuDemoPage } from './menu-demo';
export { default as ToggleMenuDemoPage } from './togglemenu-demo';
export { default as TableSortSearchPage } from './table-sort-search';
export { default as CardDemoPage } from './card';
export { default as UQDataGridDemoPage } from './data-grid';
export { default as ChartsDemoPage } from './charts';
export { default as StatisticCard } from './statistic-card';
export { default as UQLabelPage } from './label';
export { default as BreadcrumbDemoPage } from './breadcrumb';
export { default as DividerDemoPage } from './divider';
export { default as CheckboxDemoPage } from './checkbox';
export { default as SpacerDemoPage } from './spacer';
export { default as ProgressBarDemoPage } from './progress-bar';
export { default as FileReadDemoPage } from './file-read';
export { default as TooltipPage } from './tooltip';
